// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dfp7","clinicsSelect":"styles_clinicsSelect__3882Z"};